export const COLLECTION_FEE = 4500;
export const SHIPPING_FEE = 2499;
export const REDELIVER_FEE = 695;